export default __webpack_public_path__ + "static/media/work-details-glyph-16px.babb65f1.svg";